import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-gray-50 p-4 my-1 rounded-md backdrop-blur-lg" }
const _hoisted_2 = { class: "flex flex-row items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "font-bold ml-3" }
const _hoisted_5 = { class: "text-left whitespace-pre-line" }

interface IProps {
  accountImgUrl: string;
  accountName: string;
  msg: string;
}
// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
    accountImgUrl: null,
    accountName: null,
    msg: null
  },
  setup(__props: any) {

const props = __props as {
  accountImgUrl: string;
  accountName: string;
  msg: string;
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: props.accountImgUrl,
        alt: "account",
        width: "36",
        height: "36",
        style: {"width":"36px","height":"36px"},
        class: "rounded-full border-2 flex items-center justify-center"
      }, null, 8, _hoisted_3),
      _createElementVNode("h3", _hoisted_4, _toDisplayString(props.accountName), 1)
    ]),
    _createElementVNode("div", _hoisted_5, _toDisplayString(props.msg), 1)
  ]))
}
}

})